import { PATIENT_AVATAR_UPLOAD } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Response = {
    status: string;
    error: string;
};

export interface Request {
    image: string;
}

export default async (formData: FormData, patientId: string): Promise<Response> =>
    fetchWithRefresh(PATIENT_AVATAR_UPLOAD(patientId), {
        method: 'POST',
        body: formData,
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('upload patient profile avatar failed');
        }
    });
